import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInclusionsInsideOld = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 0H11v3h2v5h2v5h9V0m12.024 15H11.976a1.69 1.69 0 0 0-1.364.694l-6.45 8.868a.84.84 0 0 0 .063 1.068l2.43 2.632.029.031.004.005Q23.414 46.418 23.43 46.43a.843.843 0 0 0 1.19-.047l19.156-20.752a.844.844 0 0 0 .063-1.068l-6.45-8.868A1.69 1.69 0 0 0 36.024 15M8.112 24.87l4.724-6.496h22.328l4.724 6.496L24 42.078zM24 20h-6v3h2v4h4v-7" })
});
export default SvgInclusionsInsideOld;
